export default __webpack_public_path__ + "static/media/logo.81be7076.png";